<section  class="default-padding">
  <div class="user-view-wrapper">
    <button mat-stroked-button routerLink="/dashboard">
      <mat-icon>keyboard_arrow_left</mat-icon>Back to Dashboard
    </button>
    <h1>My Profile</h1>
    <div class="user-view">
      <div class="default-padding mat-elevation-z5">
        <h4>First Name:
          <span class="no-bold">{{ loggedUser.given_name | titlecase }}</span>
        </h4>
        <mat-divider></mat-divider>
        <h4>First Name:
          <span class="no-bold">{{ loggedUser.family_name | titlecase }}</span>
        </h4>
        <mat-divider></mat-divider>
        <h4>Email:
          <span class="no-bold">{{ loggedUser.email | titlecase }}</span>
        </h4>
        <mat-divider></mat-divider>
        <h4>
          <mat-slide-toggle [disabled]="true" [checked]="userForm.controls['email_verified'].value">
            Email Has Been Verified
          </mat-slide-toggle>
        </h4>
      </div>
    </div>
    <div class="brand"></div>
  </div>
</section>
